import React from 'react';
import { JSErrorBoundary } from '@atlassian/jira-error-boundaries/src/ui/js-error-boundary/JSErrorBoundary.tsx';
import UFOSegment from '@atlassian/jira-ufo-segment/src/index.tsx';
import { CustomerServiceMenuLinkItem } from './ui/index.tsx';

export const CustomerService = (): React.JSX.Element => (
	<UFOSegment name="nav4-sidebar-customer-service">
		<JSErrorBoundary
			fallback="flag"
			id="assets"
			packageName="jiraNavigationAppsSidebarNav4SidebarsContentCustomerService"
			teamName="Boysenberry"
		>
			<CustomerServiceMenuLinkItem />
		</JSErrorBoundary>
	</UFOSegment>
);
